import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import DeleteConfirmationDialog from '@/components/ui/dialogs/DeleteConfirmationDialog'

import { useDeleteConsultationDictaphoneMutation } from '@/core/services/consultation'

import { useAppSelector } from '@/redux/rootReducer'
import { selectConsultationById } from '@/redux/reducers/consultation.reducer'

import Transcriptions from '../components/Transcriptions'

export type TranscriptionsContainerProps = {
  consultationId?: string
}

export function TranscriptionsContainer(props: TranscriptionsContainerProps) {
  const { consultationId } = props
  const { t } = useTranslation()

  const [deletingDictaphone, setDeletingDictaphone] = useState<{ filename: string; key: string }>()
  const [openDeleteConfirmationDialog, setOpenDeleteConfirmationDialog] = useState(false)

  const consultation = useAppSelector((state) => (consultationId ? selectConsultationById(state, consultationId) : undefined))

  const [deleteDictaphone, { isLoading: isDeletingDictaphone }] = useDeleteConsultationDictaphoneMutation()

  const dictaphones = useMemo(() => {
    return (
      consultation?.dictaphones.map((dictaphone) => ({
        filename: dictaphone.filename,
        key: dictaphone.key,
        src: dictaphone.url,
        text: dictaphone.text ?? '',
      })) ?? []
    )
  }, [consultation])

  return (
    <>
      <Transcriptions
        dictaphones={dictaphones}
        onDeleteDictaphone={(filename, key) => {
          setDeletingDictaphone({ filename, key })
          setOpenDeleteConfirmationDialog(true)
        }}
      />
      <DeleteConfirmationDialog
        isDeleting={isDeletingDictaphone}
        maxWidth={800}
        onClose={() => {
          setOpenDeleteConfirmationDialog(false)
        }}
        onDelete={async () => {
          if (!consultationId || !deletingDictaphone) return
          await deleteDictaphone({ consultationId, filename: deletingDictaphone.filename, key: deletingDictaphone.key }).unwrap()
          setDeletingDictaphone(undefined)
          setOpenDeleteConfirmationDialog(false)
        }}
        open={openDeleteConfirmationDialog}
        title={t('dialog.deleteConfirmation.dictaphone.title')}
        message={t('dialog.deleteConfirmation.dictaphone.message')}
      />
    </>
  )
}

export default TranscriptionsContainer
